import React, { useState, useEffect } from "react";

import { Td, Tr } from "@lightspeed/cirrus-table";

import { Button } from "@lightspeed/flame/Button";
import { Input } from "@lightspeed/flame/Input";
import { Switch } from "@lightspeed/flame/Switch";

import { useDispatch, useSelector } from "react-redux";
import * as databaseActions from "../../../redux/actions/databaseActions";
const Row = ({ item }) => {
  const dispatch = useDispatch();
  const ui = useSelector((state) => state.ui);
  const userState = useSelector((state) => state.userState);
  const database = useSelector((state) => state.database);
  const [edit, setEdit] = useState(false);
  const [changed, setChanged] = useState(false);
  const [inputBox1, setInputBox1] = useState("");
  const [inputBox2, setInputBox2] = useState("");
  const [checkBox3, setCheckBox3] = useState(false);
  const [inputBox4, setInputBox4] = useState("");
  const [inputBox5, setInputBox5] = useState("");
  const [inputBox6, setInputBox6] = useState("");
  const [inputBox7, setInputBox7] = useState("");
  const normalAccount = item.account_id === null ? "" : item.account_id;
  const normalAccountDescription =
    item.account_description === null ? "" : item.account_description;
  const normalCheck = item.flash === "Yes" ? true : false;
  const normalCogs = item.cogs === null ? "" : item.cogs;
  const normalCogsDescription = item.cogs_description === null ? "" : item.cogs_description;
  const normalCogs2 = item.cogs2 === null ? "" : item.cogs2;
  const normalCogsDescription2 = item.cogs_description2 === null ? "" : item.cogs_description2;
  useEffect(() => {
    setInputBox1(normalAccount);
    setInputBox2(normalAccountDescription);
    setCheckBox3(normalCheck);
    setInputBox4(normalCogs);
    setInputBox5(normalCogsDescription);
    setInputBox6(normalCogs2);
    setInputBox7(normalCogsDescription2);
    if (
      normalAccount === "" &&
      normalAccountDescription === "" &&
      normalCogs === "" &&
      normalCogsDescription === "" &&
      normalCogs2 === "" &&
      normalCogsDescription2 === ""
    ) {
      setEdit(true);
    } else {
      setEdit(false);
    }
  }, [
    normalAccount,
    normalAccountDescription,
    normalCogs,
    normalCogsDescription,
    normalCogs2,
    normalCogsDescription2,
    normalCheck,
  ]);
  useEffect(() => {
    if (
      normalAccount === inputBox1 &&
      normalAccountDescription === inputBox2 &&
      normalCheck === checkBox3 &&
      normalCogs === inputBox4 &&
      normalCogsDescription === inputBox5,
      normalCogs2 === inputBox6,
      normalCogsDescription2 === inputBox7
    ) {
      setChanged(true);
    } else {
      setChanged(true);
    }
  }, [
    inputBox1,
    inputBox2,
    checkBox3,
    inputBox4,
    inputBox5,
    inputBox6,
    inputBox7,
    normalAccount,
    normalAccountDescription,
    normalCheck,
    normalCogs,
    normalCogsDescription,
    normalCogs2,
    normalCogsDescription2,
  ]);

  const handleUpdate = () => {
    dispatch(
      databaseActions.updateRetailCategory(
        userState.user.user_id,
        item.company_id,
        database.currentShop.shop_id,
        inputBox1,
        inputBox2,
        item.category_id,
        checkBox3 === true ? "Yes" : "",
        inputBox4,
        inputBox5,
        inputBox6,
        inputBox7,
        databaseActions.getShopCategories(
          database.currentCompany.id,
          userState.user.user_id,
          database.currentShop.shop_id
        )
      )
    );

    setEdit(false);
  };

  return (
    <Tr
      className={`${ui.theme === "flame" ? "" : "dark-table-row"}`}
      onDoubleClick={() => {
        setInputBox1(normalAccount);
        setInputBox2(normalAccountDescription);
        setCheckBox3(normalCheck);
        setInputBox4(normalCogs);
        setInputBox5(normalCogsDescription);
        setInputBox6(normalCogs2);
        setInputBox7(normalCogsDescription2);
        setEdit(true);
      }}
    >
      <Td>{item.company_id}</Td>
      <Td>{item.category_id}</Td>
      <Td>{item.category_name}</Td>
      <Td>{item.parentid}</Td>
      <Td>
        {!edit && (
          <div className="row-input-wrapper">
            {inputBox1}
            <div className="flex" />
          </div>
        )}
        {edit && (
          <div className="row-input-wrapper">
            <div>
              <Input
                className="input-wrapper-row-inputbox"
                type="text"
                size="small"
                value={inputBox1}
                onChange={(e) => setInputBox1(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleUpdate();
                  }
                }}
              />
            </div>
          </div>
        )}
      </Td>

      <Td>
        {!edit && (
          <div className="row-input-wrapper">
            {inputBox2}
            <div className="flex" />
          </div>
        )}

        {edit && (
          <div className="row-input-wrapper">
            <div>
              <Input
                className="input-wrapper-row-inputbox"
                type="text"
                size="small"
                value={inputBox2}
                onChange={(e) => setInputBox2(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleUpdate();
                  }
                }}
              />
            </div>
          </div>
        )}
      </Td>
      <Td>
        <Switch
          checked={checkBox3}
          onChange={(e) => {
            setEdit(true);
            setCheckBox3((oldState) => !oldState);
          }}
        />
      </Td>
      <Td>
        {!edit && (
          <div className="row-input-wrapper">
            {inputBox4}
            <div className="flex" />
          </div>
        )}

        {edit && (
          <div className="row-input-wrapper">
            <div>
              <Input
                className="input-wrapper-row-inputbox"
                type="text"
                size="small"
                value={inputBox4}
                onChange={(e) => setInputBox4(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleUpdate();
                  }
                }}
              />
            </div>
          </div>
        )}
      </Td>
      <Td>
        {!edit && (
          <div className="row-input-wrapper">
            {inputBox5}
            <div className="flex" />
          </div>
        )}

        {edit && (
          <div className="row-input-wrapper">
            <div>
              <Input
                className="input-wrapper-row-inputbox"
                type="text"
                size="small"
                value={inputBox5}
                onChange={(e) => setInputBox5(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleUpdate();
                  }
                }}
              />
            </div>
          </div>
        )}
      </Td>


      <Td>
        {!edit && (
          <div className="row-input-wrapper">
            {inputBox6}
            <div className="flex" />
          </div>
        )}

        {edit && (
          <div className="row-input-wrapper">
            <div>
              <Input
                className="input-wrapper-row-inputbox"
                type="text"
                size="small"
                value={inputBox6}
                onChange={(e) => setInputBox6(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleUpdate();
                  }
                }}
              />
            </div>
          </div>
        )}
      </Td>
      <Td>
        {!edit && (
          <div className="row-input-wrapper">
            {inputBox7}
            <div className="flex" />
          </div>
        )}

        {edit && (
          <div className="row-input-wrapper">
            <div>
              <Input
                className="input-wrapper-row-inputbox"
                type="text"
                size="small"
                value={inputBox7}
                onChange={(e) => setInputBox7(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleUpdate();
                  }
                }}
              />
            </div>
          </div>
        )}
      </Td>



      <Td textAlign="right">
        {!edit && (
          <div className="row-input-wrapper-end">
            <Button
              onClick={(_) => {
                setInputBox1(normalAccount);
                setInputBox2(normalAccountDescription);
                setEdit(true);
              }}
              size="small"
              fill="true"
            >
              Edit
            </Button>
          </div>
        )}

        {edit && (
          <div className="row-input-wrapper-end">
            {changed ? (
              <Button onClick={handleUpdate} size="small" fill="true">
                Update
              </Button>
            ) : inputBox1 === "" && inputBox2 === "" ? null : (
              <Button
                onClick={(_) => {
                  setInputBox1(normalAccount);
                  setInputBox2(normalAccountDescription);
                  setEdit(false);
                }}
                size="small"
                fill="true"
              >
                Cancel
              </Button>
            )}
          </div>
        )}
      </Td>
    </Tr>
  );
};

export default Row;
